module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bt-8037950ff48148f1cd5d75a2a84aa48f.svg";